<template>
  <div class="navigation__utility hidden-sm-and-down">
    <el-menu mode="horizontal" :default-active="$route.path">
      <el-menu-item v-for="(item, key) in utilityLinks" :key="key">
        <router-link :to="{ name: item.url }">
          {{ item.title }}
        </router-link>
      </el-menu-item>
      <!-- 
      <el-menu-item class="offline-indicator" :class="isOnline ? 'online' : 'offline'">
        {{ isOnline? $t('onlineMode'): $t('offlineMode') }}
      </el-menu-item>
       -->
      <div class="offline-indicator-spacer"></div>
    </el-menu>
  </div>
</template>

<script>
import offline from '@/offline';
import user from '@/components/user';
import nav from '@/components/navigation';
import authentication from '@/authentication';
import { mapState } from 'vuex';

export default {
  name: 'NavDesktopUtility',
  computed: {
    ...mapState(user.store.namespace, [
      'currentUser'
    ]),
    ...mapState(authentication.store.namespace, [
      'isLoggedIn'
    ]),
    ...mapState(offline.store.namespace, [
      'isOnline'
    ]),
    ...mapState(nav.store.namespace, [
      'utilityLinks',
    ])
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/base/_variables.scss';
@import 'element-theme-chalk/src/mixins/mixins.scss';

// Temporary selector
.offline-indicator-spacer {
  height: 35px;
}

.navigation__utility {
  background-color: $--color-black;

  .el-menu--horizontal {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    background-color: transparent;
    border: none;

    .el-menu-item {
      color: $--color-white;
      background-color: transparent;
      font-size: 11px;
      line-height: 100%;
      padding: 14px;
      height: 35px;
      border: none;

      &:visited {
        color: $--color-white;
      }

      &:focus,
      &:focus-within,
      &:active,
      &:hover {
        text-decoration: underline;
        color: $--color-white;
        background-color: transparent;
      }

      &.offline-indicator {
        cursor: default;
        text-decoration: none;

        &.offline {
          position: relative;
          margin-top: -2px;

          &::before {
            display: inline-block;
            position: relative;
            top: 1px;
            margin-right: 2px;
            content: "";
            background-color: $--color-white;
            mask-image: url("@/assets/images/check.svg");
            mask-repeat: no-repeat;
            mask-size: cover;
            width: 11px;
            height: 11px;
          }
        }
      }
    }
  }
}
</style>
